// extracted by mini-css-extract-plugin
export default {"button":"bdfebopt","current":"bMmcsmZO","customCard":"HF2p9CT1","accountName":"MUMjgNQ5","accountAddressBlock":"dhGETdr1","edit":"FRX4SQTO"};